<script lang="ts">
  import WizardShell from "$lib/components/onboarding/WizardShell.svelte";
  import type { Snippet } from "svelte";

  import One from "$assets/icons/1.svelte";
  import Two from "$assets/icons/2.svelte";
  import Three from "$assets/icons/3.svelte";

  interface Props {
    children: Snippet;

    currentStep: number;

    onBack?: () => void;
    onNext?: () => void;
    onFinish?: () => void;
  }

  const { children, currentStep, onBack, onFinish, onNext }: Props = $props();

  const steps = [
    {
      label: "SSO Provider",
      component: One,
    },
    {
      label: "Data Sources",
      component: Two,
    },
    {
      label: "Review",
      component: Three,
    },
  ];
</script>

{#snippet Heading()}
  <div class="flex items-baseline gap-3">
    <span>Security Onboarding</span>
    <span class="font-mono bg-[#E5F0F9] rounded-sm text-sm px-2 py-0.5 text-offblack">In Progress</span>
  </div>
{/snippet}

<WizardShell {currentStep} {steps} {onBack} {onFinish} {onNext} header={Heading}>
  {@render children()}
</WizardShell>
